var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100-perc",staticStyle:{"z-index":"0"}},[_c('p',{staticClass:"font-18 ml-5 pt-1 mb-0",attrs:{"id":"titulo"}},[_vm._v("Detalhes do departamento")]),_c('div',{staticClass:"charts px-2"},[_c('MovimentacaoEstoqueDepartamento',{staticClass:"w-50-perc"}),_c('RupturasDepartamento',{staticClass:"w-50-perc"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }